export class GatewayLogParseArray extends Array<GatewayLogParse>  {

    constructor(...items: GatewayLogParse[]) {
        super(...items);
        Object.setPrototypeOf(this, GatewayLogParseArray.prototype);
    }

}

export class GatewayLogParse {
    ID: number;
    Gateway_ID: number;
    Date: Date;
    Gateway: string;
    Result: string;
    Amount: number;
    ResultCode: number;

    PNRef: string;
    MSG: string;
    Authcode: string;
    AVSADDR: string;
    AVSZIP: string;
    IAVS: string;
    IsSettled: boolean;
    IsVoided: boolean;
    IsCreditRefund: boolean;
    TransactionStatus: string;

    Invoice_ID: number;
    InvoiceNumber: string;

    Member_ID: number;
    MemberFullName: string;
    MemberCompanyName: string;
}
